import { CampaignZeroState } from 'ui/illustrations';
import { CampaignEditorError } from './CampaignEditorError';

export const CampaignNotFoundError = ({ retry }: { retry?: () => void }) => (
  <CampaignEditorError
    retry={retry}
    image={<CampaignZeroState height={296.5} width={296.5} />}
    message={'It may have been deleted, or there could be a typo in the URL.'}
    title={"Oops... we couldn't find that campaign."}
  />
);
